import dynamic from "next/dynamic";
const CAccordion = dynamic(() => import("./custom-accordion"));

interface AccordionProps {
  data?: any;
}

const Accordion: React.FC<AccordionProps> = ({ data }) => {
  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-25 md:py-[83px] overflow-hidden">
      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-center justify-center mx-auto">
          <h2 className="text-heading-1 font-bold text-primary-text mb-[40px] md:mt-[-25px]  max-w-[1230px] mx-auto">
            {data?.title ?? data?.Title ?? ""}
          </h2>

          <div className="grid md:grid-cols-12 gap-6 md:gap-[30px] items-center w-full">
            <div className="xl:col-span-12 md:col-span-12">
              <CAccordion data={data?.faq ?? data?.Tabs ?? []} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accordion;
